<template>
  <section>
    <div class="container col-lg-9 mx-auto pb-5 mb-5">
      <div
        class="rounded-card bg-light shadow p-5 row d-flex align-items-center position-relative"
      >
        <div class="px-0 px-md-5">
          <header-five text="Related blog posts" class="font-poppins" />
          <carousel-articles v-if="articles.length" :articles="articles" />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "RelatedBlogPostsSection",
};
</script>
<script setup>
import { blogApi } from "@/main.ts";
import { defineProps, watch, ref } from "vue";
import HeaderFive from "@/components/base-components/HeadingFive";
import CarouselArticles from "@/components/blog/show/CarouselArticles";

const articles = ref([]);

const props = defineProps({
  categoryId: {
    type: Number,
  },
});

watch(
  () => props.categoryId,
  (newValue, oldValue) => {
    if (newValue !== undefined && newValue !== oldValue) {
      loadArticles();
    }
  }
);

const loadArticles = async () => {
  try {
    articles.value = (
      await blogApi.get(`/blog-categories/${props.categoryId}`)
    ).data.data;
  } catch (e) {
    console.log(e);
  }
};
</script>

<style scoped></style>
